import { useState } from 'react'
import { KioskMode } from './components/kiosk/KioskMode'
import { AdminMode } from './components/admin/AdminMode'
import { layout } from './lib/ui-primitives'

type AppMode = 'kiosk' | 'admin'

export default function App() {
  const [mode, setMode] = useState<AppMode>('kiosk')
  const [adminAuth, setAdminAuth] = useState(false)

  const handleAdminAccess = () => {
    setMode('admin')
  }

  const handleExitAdmin = () => {
    setMode('kiosk')
    setAdminAuth(false)
  }

  return (
    <div className={layout.page}>
      {mode === 'kiosk' ? (
        <KioskMode onAdminAccess={handleAdminAccess} />
      ) : (
        <AdminMode
          isAuthenticated={adminAuth}
          onAuthenticate={setAdminAuth}
          onExit={handleExitAdmin}
        />
      )}
    </div>
  )
}
